import React from 'react';
import { VStack, Input, Button } from '@chakra-ui/react';
import { Field } from '@/components/ui/field';

interface ProfileEditContentProps {
  displayName: string;
  userId: string;
  onDisplayNameChange: (name: string) => void;
  onUserIdChange: (id: string) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const ProfileEditContent: React.FC<ProfileEditContentProps> = ({
  displayName,
  userId,
  onDisplayNameChange,
  onUserIdChange,
  onSubmit,
  isLoading = false,
}) => {
  return (
    <VStack gap={6} align="stretch" pb={4}>
      <Field label="表示名" required>
        <Input
          placeholder="表示名を入力"
          value={displayName}
          onChange={e => onDisplayNameChange(e.target.value)}
          size="lg"
        />
      </Field>

      <Field label="ユーザーID" required>
        <Input
          placeholder="ユーザーIDを入力（@なし）"
          value={userId}
          onChange={e => onUserIdChange(e.target.value)}
          size="lg"
        />
      </Field>

      <Button
        colorPalette="teal"
        size="lg"
        w="full"
        onClick={onSubmit}
        disabled={!displayName.trim() || !userId.trim()}
        loading={isLoading}
      >
        更新する
      </Button>
    </VStack>
  );
};
